/* eslint-disable no-unused-vars */
import React, { useState, useEffect, useContext } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import SelectDateFilter from 'modules/common/components/SelectDateFilter';
import PropTypes from 'prop-types';
import withDashboard from '../../../common/hoc/withDashboard';
import CmsContext from '../../../../context/CmsContext';

import * as actions from '../action';
import * as c from '../constant';
import RptbChartComponent from '../components/RptbChartComponent';

const filter = {
  transaction_type: 'ALL',
};

function RptbDashboardContainer({
  graphStats,
  getGraphStats,
}) {
  const [filterData, setFilterData] = useState(filter);
  const [isLoading, setIsLoading] = useState(true);

  const cmsContext = useContext(CmsContext);
  const CMS_VARIABLES = cmsContext.findByType('VARIABLES')

  const renderLegends = (dt) =>
    dt.map((x) => {
      return (
        <div key={x.name} className="legend-item">
          <div
            style={{
              background: `${x.color}`,
              width: 20,
              height: 20,
              marginRight: 20,
            }}
          />
          <div className="legend-text">{x.name}</div>
        </div>
      );
    });

  const handleOnSubmit = (data) => {
    const args = {
      ...data,
      permit_type: 'Real Property Tax (RPTAX)',
    }
    getGraphStats(args);
  };

  // const handleOnSubmit = ({ type, from, to }) => {
  //   // eslint-disable-next-line no-console
  //   getGraphStats({
  //     period: type,
  //     date_from: from,
  //     date_to: to,
  //     permit_type: 'Real Property Tax (RPTAX)',
  //   });
  // };

  useEffect(() => {
    getGraphStats();
    setIsLoading(false);
    return () => {
      setIsLoading(false);
    };
  }, []);

  return (
    <div className="dashboard-card">
      <div className="row mb-3">
        <div className="col-12">
          <div className="main-text">Statistics</div>
        </div>
        <div className="col-12">
          <SelectDateFilter onSubmit={handleOnSubmit} />
        </div>
        <div className="col-12">
          <RptbChartComponent chartData={graphStats} />
        </div>
        <div className="legends-wrapper area px-3 w-100">
          <div
            className="render-chart-legends"
            style={{
              display: 'flex',
              alignItems: 'center',
              flexDirection: 'row',
              flexWrap: 'wrap',
            }}
          >
            {_.get(CMS_VARIABLES, 'LGU_NAME') !== 'City of Borongan' ? (
                renderLegends(c.LEGENDS_WITH_TAX_CLEARANCE)
              ) : (
                renderLegends(c.LEGENDS)
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

RptbDashboardContainer.propTypes = {
  graphStats: PropTypes.instanceOf(Array).isRequired,
  getGraphStats: PropTypes.instanceOf(Function).isRequired,
};

const mapStateToProps = ({ api }) => ({
  graphStats: _.get(api, `${c.GET_GRAPH_STATS}.list`) || [],
});

const enhance = _.flowRight([
  withDashboard,
  withRouter,
  connect(mapStateToProps, actions),
]);

export default enhance(RptbDashboardContainer);
